import { Row } from 'antd'
import MachineList from 'app/components/Core/LineItem/MachineList'
import * as React from 'react'

type Props = {
  rental: IRental
}
const Products: React.FC<Props> = ({ rental }) => {
  if (!rental?.products.length) return null

  return (
    <If condition={rental?.products.length}>
      <Row gutter={[{ xs: 0, md: 12 }, 12]}>
        <MachineList
          collection={rental?.products}
          props={{ filter: rental?.status !== 'canceled' }}
        />
      </Row>
    </If>
  )
}

export default Products
